<input
  matInput
  [(ngModel)]="sectionTitle"
  class="custom-title-input f_feedback-providers-title-input"
  type="text"
  (keydown.enter)="$event.preventDefault(); saveTitle()"
  (blur)="saveTitle()"
  [attr.placeholder]="'translations.clickToEditSectionTitle' | transloco"
  [attr.aria-label]="'translations.global.ariaLabels.editSectionTitle' | transloco"
  autocomplete="off"
/>
